/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import statsType from '../proptypes/stats';
import { DataDescription } from './Typography';

const StatWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StatList = ({
  stats,
  withIndex,
  title,
}) => (
  <div>
    {title && <DataDescription large>{title}</DataDescription>}
    {
      stats.map((rawStat, outerIndex) => {
        const stat = Array.isArray(rawStat) ? rawStat : rawStat.stat;
        const { href } = rawStat;
        const Wrapper = href ? StatWrapper.withComponent('a') : StatWrapper;
        const statWrapperProps = {
          key: `stat-${outerIndex}`,
          ...(href ? { href } : {}),
        };

        return (
          <Wrapper {...statWrapperProps}>
            {
              stat.map((column, innerIndex) => (
                <DataDescription key={`column-${innerIndex}`} light={innerIndex} large>
                  {innerIndex === 0 && withIndex && `${outerIndex + 1}. `}
                  {column}
                </DataDescription>
              ))
            }
          </Wrapper>
        );
      })
    }
  </div>
);

StatList.defaultProps = {
  withIndex: false,
  title: null,
};

StatList.propTypes = {
  stats: statsType.isRequired,
  withIndex: PropTypes.bool,
  title: PropTypes.string,
};

export default StatList;
